import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetCertificationAction } from '../../../../ts/ServerApi/types/actionNames';
import { setCertificationAction } from '../../../actions/spaces/SetCertificationAction';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const SetCertificationDatasourceAction: IEntityAction<IContentInfo<'datasource'>, ISetCertificationAction> = {
  name: EntityActionNames.SetCertification,
  translateName: Messages.editCertification,
  isVisible: (items, state) => FeatureFlags.dqcertificationVisualDesignEnabled,
  isClickable: (availableActions: ISetCertificationAction) => !!(availableActions && availableActions.setCertification),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error(Messages.setCertificationError());
    }

    return setCertificationAction(items[0]);
  }
};

/**
 * TODO: at some point we should determine if we need this other action,
 * if cataloging isn't enabled then you can't get to the list view or the place page for db/tb
 * and therefore this isVisible is probably not really that useful
 */
export const SetCertificationDatabaseAndTableAction: IEntityAction<IContentInfo<'database'> | IContentInfo<'table'>, ISetCertificationAction> = {
    name: EntityActionNames.SetCertification,
    translateName: Messages.editCertification,
    isVisible: (items, state) => selectCatalogingOnSiteEnabled(state),
    isClickable: (availableActions: ISetCertificationAction) => !!(availableActions && availableActions.setCertification),
    createReduxAction: (items) => {
      if (!items || items.length === 0 || items.length > 1) {
        throw new Error(Messages.setCertificationError());
      }

      return setCertificationAction(items[0]);
    }
  };
